import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import communityService from "../../api/communityService";

export const updatePost = createAsyncThunk(
  "frontend/update-post",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await communityService.editPost(payload);
      if (response) {
        return {
          editPost: response?.data,
          actionFlag: "UPDATE_POST",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.message ||
        error?.response?.data?.message ||
        "Failed to update post";
      return rejectWithValue(errorMessage);
    }
  },
);
export const getPreviewLink = createAsyncThunk(
  "frontend/getPreviewLink",
  async (payload) => {
    try {
      const response = await communityService.getPreviewLink(payload);
      if (response) {
        return {
          editPost: response?.data,
          success: "",
          error: "",
        };
      }
    } catch (error) {
      console.log(error);
    }
  },
);

const initialState = {
  PreviewLink: {},
  editPost: {},
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  successMessage: "",
};

const editPostSlice = createSlice({
  name: "editPost",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updatePost.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(updatePost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.editPost = action.payload.editPost || {};
        state.successMessage =
          action.payload.message || "Successfully fetched investment report";
        state.errorMessage = "";
      })
      .addCase(updatePost.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getPreviewLink.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getPreviewLink.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.PreviewLink = action.payload.editPost || {};
        state.successMessage =
          action.payload.message || "Successfully preview link";
        state.errorMessage = "";
      })
      .addCase(getPreviewLink.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      });
  },
});

export default editPostSlice.reducer;
